export default "__VITE_ASSET__pVZeB74B__"